import config from "../config"
const baseUrl = config.base_url + "container/phenology/indicator/quest/"
export default {
    page: {
        url: baseUrl + "page/{page}/{size}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    listByPhenology: {
        url: baseUrl + "listByPhenology",
        type: "get",
    },
    deleteByPhenology: {
        url: baseUrl + "deleteByPhenology",
        type: "get",
    },
    batchAdd: {
        url: baseUrl + "batchAdd",
        type: "get",
    }
}
